import { MEDIUM } from "../../../constants/breakpoints/breakpoints.js";
import "@mui/material/styles";
import "../../../themes/shadows/shadows.js";
import { typography } from "../../../themes/typography/typography.js";
import "react/jsx-runtime";
import "color-alpha";
import "@mui/material";
import "../../../themes/external-theme/external-theme.js";
import "../../../themes/pickers-popper/pickers-popper.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../constants/create-theme/create-theme.js";
import "../../../constants/colors/palette.js";
import "../../../themes/alert/alert.js";
import "../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../themes/button/button.js";
import "../../../themes/button/styles/external/bordered.styles.js";
import "../../../themes/button/styles/external/filled.styles.js";
import "../../../themes/button/styles/internal/bordered.styles.js";
import "../../../themes/button/styles/internal/borderless.styles.js";
import "../../../themes/button/styles/internal/filled.styles.js";
import "../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../themes/checkbox/checkbox.js";
import "../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../themes/form-control-label/form-control-label.js";
import "../../../themes/radio/radio.js";
import "../../../themes/switch/switch.js";
const root = (theme) => ({
  py: 12,
  backgroundColor: theme.palette.grey[100],
  display: "flex",
  justifyContent: "center",
  [theme.breakpoints.down(MEDIUM)]: {
    py: 3
  }
});
const container = (theme) => ({
  maxWidth: "1440px",
  mx: 4.5,
  [theme.breakpoints.down(MEDIUM)]: {
    mx: 3
  }
});
const title = (theme) => ({
  textAlign: "center",
  ...typography["DM Serif H2"],
  mb: 6,
  [theme.breakpoints.down(MEDIUM)]: {
    ...typography["DM Serif H4"],
    mb: 3
  }
});
const content = (theme) => ({
  backgroundColor: theme.palette.grey[100],
  listStyle: "auto",
  p: {
    ...typography["Lato Body 1"],
    [theme.breakpoints.down(MEDIUM)]: {
      ...typography["Lato Body 2"]
    }
  },
  h2: {
    textAlign: "center",
    ...typography["DM Serif H2"],
    mb: 6,
    [theme.breakpoints.down(MEDIUM)]: {
      textAlign: "left",
      ...typography["DM Serif H4"],
      mb: 3
    }
  },
  ol: {
    pl: 0,
    listStyle: "auto",
    [theme.breakpoints.down(MEDIUM)]: {
      pl: 2.5
    },
    " p": {
      margin: 0,
      padding: 0
    }
  },
  ul: {
    listStyleType: "disc",
    pl: 0,
    [theme.breakpoints.down(MEDIUM)]: {
      pl: 2.5
    }
  },
  "p + h2": {
    mt: 10,
    [theme.breakpoints.down(MEDIUM)]: {
      mt: 6
    }
  },
  "ul p": {
    margin: 0,
    padding: 0
  }
});
const button = (theme) => ({
  textAlign: "center",
  pt: 6,
  [theme.breakpoints.down(MEDIUM)]: {
    pt: 4
  }
});
export {
  button,
  container,
  content,
  root,
  title
};
